import { routerSelectors } from 'src/app/core/router/router.selectors'

import { Dictionary } from '@ngrx/entity'
import { createFeatureSelector, createSelector } from '@ngrx/store'

import { InternalEvent } from './internal-event'
import * as fromInternalEvent from './internal-event.reducer'

const state = createFeatureSelector<fromInternalEvent.InternalEventState>(
  fromInternalEvent.FEATURE_NAME
)

const adapter = fromInternalEvent.adapter.getSelectors()

const selectIds = createSelector(state, adapter.selectIds)
const selectAll = createSelector(state, adapter.selectAll)
const selectEntities = createSelector(state, adapter.selectEntities)

const selectIsLoading = createSelector(state, (state) => state.isLoading)

const selectState = createSelector(state, (state) => state && state)

const selectById = createSelector(
  selectEntities,
  (entities: Dictionary<InternalEvent>, id: number) => {
    return entities[id]
  }
)

const selectByFilter = createSelector(
  selectAll,
  (
    entities: InternalEvent[],
    filter?: { field: string; value: string | number }
  ) => {
    if (filter) {
      return entities.filter((entity) => entity[filter.field] == filter.value)
    }

    return entities
  }
)

const selectIdRouteParam = createSelector(
  routerSelectors.selectRouteParams,
  (params) => {
    return params && params.internalEventId
  }
)

const selectCount = createSelector(
  selectAll,
  (entities) => entities && entities.length
)

export const internalEventSelectors = {
  selectState,
  selectIsLoading,
  selectById,
  selectIds,
  selectEntities,
  selectAll,
  selectByFilter,
  selectIdRouteParam,
  selectCount
}
